/**
 * Created by rastwe on 1/16/2017.
 * @module $Name$
 * @extends React.Component
 */
import React from 'react';
import styled from 'styled-components';
import './main.less';
import './index.scss';
import {useDispatch, useSelector} from 'react-redux';
import {versionUpgrade} from '../../../features/version-update/version-update';
import Modal from '../Modal/Modal';
import {currentResource} from '../../../common/utils/utils';
import '@ey/motif-react-wrapper/ey-asu-motif.css';
import '@ey/styled-theme/styles.css';

function Main(props) {
	const appVersionState = useSelector((store) => {
		return store.appVersion;
	});
	const dispatch = useDispatch();
	return (
		<>
			<section className="main container">
				<section className="rootcontainerWrapper">{props.children}</section>
			</section>
			<Modal
				title={currentResource.labels.softwareUpdate}
				closeTitle={currentResource.common.close}
				hideCloseButton
				confirmBtnTitle={currentResource.labels.updateNow}
				closeBtnTitle={currentResource.labels.updateLater}
				modalContainerClass="softwareUpdateContainer"
				modalsize="small"
				onHide={() => {
					dispatch(versionUpgrade(false));
				}}
				onOkClick={() => {
					localStorage.setItem('app.version', appVersionState.version);
					window.location.reload();
				}}
				show={appVersionState.upgrade}
				showButtons
			>
				<PopupContent>{currentResource.labels.updateMsg}</PopupContent>
			</Modal>
		</>
	);
}

export default Main;

const PopupContent = styled.section`
	font-size: var(--px-12);
	margin: var(--px-20) var(--px-20);
	line-height: var(--px-20);
	color: var(--neutrals-900);
`;
